const HIDDEN_TAG_NAMES: string[] = [
  "salary_override_jem_mobile",
  "start_of_employment_date",
];

export const isHiddenTag = (tag: { name: string; category: string }): boolean =>
  HIDDEN_TAG_NAMES.includes(tag.name) ||
  HIDDEN_TAG_NAMES.includes(tag.category);

export default HIDDEN_TAG_NAMES;
